import { Box } from '@joinrepublic/dls-ui-kit';

export const NewsCardSkeleton = () => (
  <Box
    w={{ base: '320px', sm: '440px', md: '510px' }}
    h={{ base: '210px', sm: '290px', md: '340px' }}
    borderRadius={{ base: 'lg', sm: 'xl' }}
    bgColor="grey.100"
    flexShrink={0}
  ></Box>
);
